import PropTypes from 'prop-types';
// @mui
import { alpha, useTheme, styled } from '@mui/material/styles';
import { Box, Stack, Grid, Button, Container, Typography, LinearProgress } from '@mui/material';
// hooks
import { useNavigate } from 'react-router';
import useResponsive from '../../hooks/useResponsive';
// utils
import { fPercent } from '../../utils/formatNumber';
// _mock_
import { _skills } from '../../_mock';
// components
import Image from '../../components/Image';
import Iconify from '../../components/Iconify';
import { MotionInView, varFade } from '../../components/animate';
import Markdown from '../../components/Markdown';

// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center',
  paddingTop: theme.spacing(5),
  paddingBottom: theme.spacing(5),
  [theme.breakpoints.up('md')]: {
    textAlign: 'center',
  },
}));

// ----------------------------------------------------------------------

export default function DownloadButton({ block }) {
  const theme = useTheme();
  const navigate = useNavigate();

  const isDesktop = useResponsive('up', 'md');

  const isLight = theme.palette.mode === 'light';
  const shadow = `-40px 40px 80px ${alpha(isLight ? theme.palette.grey[500] : theme.palette.common.black, 0.48)}`;

  return (
    <RootStyle>
      <Container sx={{ justifyContent: 'center' }}>
        <Grid container spacing={3} alignItems="center" justifyContent="center">
         
         
          <Grid item xs={12} md={5}>
            <MotionInView variants={varFade().inRight}>
              <Stack direction="row" spacing={2}>
                <Box sx={{ p: 3 }}>
                  {/* <Markdown children={block.description} /> */}
                  <Typography variant="h6" sx={{ mb: 3, mt: 3 }}>{block.title}</Typography>

                <Button
                  fullWidth
                  size="large"
                  color="inherit"
                  variant="contained"
                  sx={{ mt: 5 }}
                  onClick={() => {
                    const link = document.createElement('a');
                    link.href = `${block.buttonLink}`;
                    link.setAttribute('download', '');
                    link.style.display = 'none';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                  }}
                >
                  <Iconify icon={'eva:file-text-outline'} width={40} height={40} />

                  &nbsp;
                  {block.buttonText}
                </Button>
                </Box>
                <Box sx={{ p: 3 }}>
                  {/* <Markdown children={block.pdf} /> */}
                  <Typography variant="h6" sx={{ mb: 3, mt: 3 }}>{block.description}</Typography>
                <Button
                  fullWidth
                  size="large"
                  color="inherit"
                  variant="contained"
                  sx={{ mt: 5 }}
                  onClick={() => {
                    const link = document.createElement('a');
                    link.href = `${block.buttonTitle}`;
                    link.setAttribute('download', '');
                    link.style.display = 'none';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                  }}
                >
                  <Iconify icon={'eva:file-text-outline'} width={40} height={40} />
                  &nbsp;
                  {block.pdfText}
                </Button>
                </Box>
              </Stack>
            </MotionInView>
          </Grid>
        </Grid>
      </Container>
    </RootStyle>
  );
}

// ----------------------------------------------------------------------

ProgressItem.propTypes = {
  progress: PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.number,
  }),
};

function ProgressItem({ progress }) {
  const { label, value } = progress;

  return (
    <Box sx={{ mt: 3 }}>
      <Box sx={{ mb: 1.5, display: 'flex', alignItems: 'center' }}>
        <Typography variant="subtitle2">{label}&nbsp;-&nbsp;</Typography>
        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
          {fPercent(value)}
        </Typography>
      </Box>
      <LinearProgress
        variant="determinate"
        value={value}
        sx={{
          '& .MuiLinearProgress-bar': { bgcolor: 'grey.700' },
          '&.MuiLinearProgress-determinate': { bgcolor: 'divider' },
        }}
      />
    </Box>
  );
}
